// The API lives on its own host. Keep the protocol of the page so an http page
// does not fire a request the browser would block as mixed content.
const backendUrl = (path) => {
    const protocol = window.location.href.toLowerCase().startsWith('https') ? 'https' : 'http';

    return `${protocol}://back.hernizona.online${path}`;
}

export default backendUrl
